const PORTAL_API = `https://central-de-suporte-tecnico-d71b7ec7.base44.app/api/apps/692ce8b41b53f8d1d71b7ec7/functions`;

// v2 - lê body independente do status HTTP
const invokePublic = async (funcName, params) => {
  const res = await fetch(`${PORTAL_API}/${funcName}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(params)
  });
  const data = await res.json();
  if (res.status === 500) throw new Error(data.error || "Erro interno");
  return data;
};

export const portalClienteLogin    = (params) => invokePublic("portalClienteLogin", params);
export const portalClienteTarefas  = (params) => invokePublic("portalClienteTarefas", params);
export const portalClienteCollabs  = (params) => invokePublic("portalClienteCollabs", params);
export const portalClienteChamadas = (params) => invokePublic("portalClienteChamadas", params);
export const portalClienteToken    = (params) => invokePublic("portalClienteToken", params);


// Implantação — checklist visual (adicionado 2026-09-26, sem alterar nada acima)
export const portalClienteImplantacao = (params) => invokePublic("portalClienteImplantacao", params);
export const portalClienteAtualizarEtapa = (params) => invokePublic("portalClienteAtualizarEtapa", params);
